
interface PlayIconProps {
    className?: string;
}


export function PlayIcon({ className }: PlayIconProps) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 24 24">
            <path d="M8 5v14l11-7z" />
        </svg>
    );
}
